import { getFileIndex } from "@root/store/selectors/entities";
import { useSelector } from "react-redux";
import { LegalComplianceTextArea } from "./LegalComplianceTextArea";
import { StayledInputContainer } from "@root/components/dashboard/style";
import { useRef } from "react";

export function LegalComplianceInput({
  fileContainerRef,
  submitHandler,
  onChangehandler,
  input,
  onSubmit,
  loading,
  setInput,
  pid,
  name,
  px = 0,
  stopPolling,
  currentStatus,
  ...props
}: any) {
  const inputRef: any = useRef(null);
  const fileIndex = useSelector(getFileIndex);

  return (
    <StayledInputContainer {...props} px={px}>
      <LegalComplianceTextArea
        onSubmit={onSubmit}
        fileIndex={fileIndex}
        onSend={submitHandler}
        inputRef={inputRef}
        onChangehandler={onChangehandler}
        input={input}
        loading={loading}
        name={name}
        pid={pid}
        stopPolling={stopPolling}
        currentStatus={currentStatus}
      />
    </StayledInputContainer>
  );
}
